import { ThemeProvider } from '@emotion/react';
import { lightTheme } from '~/_shared/themes/light.theme';
import { MapPdfSummaryComponent } from '~/map/page/summary/mapPdfSummary.component';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';
import { ExportReportActiveType } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

type PdfReportPageProps = Readonly<{
  mapShareId: string;
  mapId: number | null;
}>;

export const ReportPageComponent = (props: PdfReportPageProps) => {
  const exportReportState = useToolsStateExportReportSelector();

  return (
    <ThemeProvider theme={lightTheme}>
      <div>PDF report for mapShareId: {props.mapShareId}</div>
      <div>Map ID: {props.mapId}</div>
      <div>{exportReportState.params?.type === ExportReportActiveType.Location ? exportReportState.params.data.title : 'No title for this report'}</div>
      <MapPdfSummaryComponent />
    </ThemeProvider>
  );
};
